// Product-specific size guides use the measurement table already in the description.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-size-guide]');
  if (!trigger) return;
  const product = trigger.closest('.wt-product') || document;
  const table = product.querySelector('[id^="Description-"] table');
  if (!table) return;
  let dialog = document.getElementById('jr-size-dialog');
  if (!dialog) {
    dialog = document.createElement('dialog');
    dialog.id = 'jr-size-dialog';
    dialog.className = 'jr-shopping-dialog';
    dialog.setAttribute('aria-labelledby', 'jr-size-title');
    dialog.innerHTML = '<button type="button" class="jr-dialog-close" aria-label="Close size guide">×</button><h2 id="jr-size-title">Size guide</h2><p>Garment measurements in inches. Compare with a similar item you own.</p><div class="jr-size-content"></div>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => document.body.classList.remove('jr-dialog-open'));
  }
  const content = dialog.querySelector('.jr-size-content');
  content.replaceChildren(table.cloneNode(true));
  const chart = table.closest('.rte');
  const tip = Array.from(chart?.querySelectorAll('p') || []).find(p => /fit tip|recommend.*size down/i.test(p.textContent));
  if (tip) content.prepend(tip.cloneNode(true));
  dialog.showModal();
  document.body.classList.add('jr-dialog-open');
});

class CartVariantEditor extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', e => e.stopPropagation());
    this.querySelector('[data-apply-variant]').addEventListener('click', () => this.apply());
  }
  async apply() {
    const select = this.querySelector('select');
    if (select.value === this.dataset.variant) return;
    const button = this.querySelector('button');
    const error = this.querySelector('[role="alert"]');
    button.disabled = true;
    error.textContent = '';
    try {
      const root = window.Shopify.routes.root;
      const currentResponse = await fetch(`${root}cart.js`);
      if (!currentResponse.ok) throw new Error('Unable to load your bag. Please try again.');
      const current = await currentResponse.json();
      const line = current.items.find(item => item.key === this.dataset.key);
      if (!line) throw new Error('Your bag has changed. Refresh and try again.');
      const matching = current.items.find(item => String(item.variant_id) === select.value && !item.selling_plan_allocation && Object.keys(item.properties || {}).length === 0);
      const quantity = line.quantity + (matching?.quantity || 0);
      const selected = select.selectedOptions[0];
      const maximum = Number(selected.dataset.max || Infinity);
      const minimum = Number(selected.dataset.min || 1);
      const step = Number(selected.dataset.step || 1);
      if (quantity > maximum || quantity < minimum || (quantity - minimum) % step !== 0) throw new Error('This option is not available in the quantity in your bag. Please adjust the quantity first.');
      const updates = { [line.key]: 0, [matching?.key || select.value]: line.quantity + (matching?.quantity || 0) };
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }),
      });
      const state = await response.json();
      if (!response.ok || state.errors) throw new Error(state.description || state.errors || 'Unable to change this option. Please try again.');
      if (location.pathname === window.routes.cart_url) { location.reload(); return; }
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !state.sections?.['cart-drawer']) { location.reload(); return; }
      drawer.renderContents(state, false);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      drawer.querySelector('[data-apply-variant]')?.focus();
    } catch (e) {
      error.textContent = e.message;
      button.disabled = false;
    }
  }
}
customElements.define('cart-variant-editor', CartVariantEditor);
